import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'
import HttpBackend from 'i18next-http-backend'

const i18nInstance = i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '{{lng}}',
      request: function (options, lang, payload, callback) {
        import(`../translations/${lang}.js`)
          .then((mod) => {
            // callback first argument is error & second argument is data
            callback(false, {
              status: 200,
              data: mod.default,
            })
          })
          .catch(() => {
            // for unknown languages
            callback(false, {
              status: 200,
              data: {},
            })
          })
      },
    },
    // load: 'languageOnly',
    // loadPath: '/i18n/{{lng}}/{{lng}}.json',

    fallbackLng: 'en',
    // fallbackLng: 'hi',
    // fallbackLng: 'ar',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: '.', // we use content as keys

    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
      useSuspense: false,
    },
  })
  .then(() => Promise.resolve(true))

export default i18nInstance
